module.exports = __webpack_public_path__ + "static/media/19-15.31a917a7.mp3";